import React from 'react';
import { Redirect } from 'react-router-dom';
import { has } from 'ramda';

import { defaultApprovalListFilters } from 'constants/defaultFilters';

const withApprovalRedirect = (WrappedComponent, route, filters = defaultApprovalListFilters, defaultStatus = 'inwork', routeParams = {}) =>
    function ApprovalRedirect(props) {
        const { match: { params: { status } } } = props;

        return has(status, filters) ? (
            <WrappedComponent {...props} />
        ) : (
            <Redirect to={route.stringify({ status: defaultStatus, ...routeParams })} />
        );
    };

export default withApprovalRedirect;
